import { makeStyles } from "@mui/styles";
import { Grid, IconButton, Snackbar } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CopyToClipboard from "react-copy-to-clipboard";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    "& > *": {
      width: "100%",
    },
    textAlign: "center",
  },
  errorImage: {
    height: "60vh",
  },
  errorMessage: {
    color: "red",
    fontSize: "1.5em",
    margin: ".5em",
  },
}));

const ErrorFallback = ({ error, image }) => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.root}
    >
      <img src={image} className={classes.errorImage} alt={"error"} />
      <p className={classes.errorMessage}>
        Oops! Something went wrong.{" "}
        <span dangerouslySetInnerHTML={{ __html: error }} />
        <CopyToClipboard
          onCopy={handleClick}
          text={error.replace(/<[^>]*>?/gm, "")}
        >
          <IconButton aria-label="delete" color="primary">
            <ContentCopyIcon />
          </IconButton>
        </CopyToClipboard>
      </p>
      <p className={classes.errorMessage}>
        For support contact us on{" "}
        <a href="slack://channel?team=T02FD15NQ&id=C02QJJH0KU1">
          #ml-infra-issues
        </a>
      </p>

      <a href="https://storyset.com/web">Web illustrations by Storyset</a>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        autoHideDuration={3000}
        onClose={handleClose}
        message="Error message copied to clipboard"
      />
    </Grid>
  );
};

export default ErrorFallback;
